var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31509 1.55108C7.61444 0.629765 8.91785 0.629764 9.2172 1.55107L10.2519 4.7356C10.3858 5.14762 10.7697 5.42658 11.203 5.42658H14.5514C15.5201 5.42658 15.9229 6.6662 15.1392 7.2356L12.4302 9.20375C12.0798 9.45839 11.9331 9.90976 12.067 10.3218L13.1017 13.5063C13.401 14.4276 12.3466 15.1937 11.5628 14.6243L8.85393 12.6562C8.50344 12.4016 8.02885 12.4016 7.67836 12.6562L4.96944 14.6243C4.18573 15.1937 3.13125 14.4276 3.4306 13.5063L4.46531 10.3218C4.59919 9.90976 4.45253 9.45839 4.10204 9.20375L1.39312 7.2356C0.609408 6.6662 1.01218 5.42658 1.98091 5.42658H5.32932C5.76254 5.42658 6.1465 5.14762 6.28037 4.7356L7.31509 1.55108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2aeedc14b448d6a39b003f0de24bb439.svg";
export { ForwardRef as ReactComponent };